// The signed-in reader's plan as the site names it, and today's credits, from their account record
const PLAN_NAMES = {pro: "Storyteller", business: "Bard"};

export function planName(user) {
    if (!user) return null;
    if (user.planName === "canceled") return "No plan";
    return PLAN_NAMES[user.planName] || "Free";
}

export function planSummary(user) {
    if (!user) return null;
    const credits = typeof user.availableCredits === "number" ? Math.max(0, user.availableCredits) : null;
    return credits === null ? planName(user) : `${planName(user)} · ${credits} credit${credits === 1 ? "" : "s"} left today`;
}

// Credits each plan gets every day, as the nightly job sets them
const DAILY_CREDITS = {free: 5, starter: 5, pro: 100, business: 300, canceled: 0};

export function dailyCredits(user) {
    if (!user) return null;
    return DAILY_CREDITS[user.planName] ?? DAILY_CREDITS.free;
}
